<!--
单个消息item
-->
<template>
  <div class="m-item-max-box" :class="mine ? 'm-item-max-box-end' : ''">
    <div class="m-item" :class="mine ? 'flex-right' : ''">
      <div v-if="!mine"><img class="head-img" src="../../../assets/images/logo.png"></div>
      <div v-if="!mine" class="left-right to-left"></div>
      <div class="message-and-time">
        <p class="time" :class="mine ? 'message-align-right' : ''">{{topText}}</p>
        <p class="content">{{mainText}}</p>
      </div>
      <div v-if="mine" class="left-right to-right"></div>
      <div v-if="mine"><img class="head-img" src="../../../assets/images/logo.png"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MItem",
    props: {
      //是否是自己发的
      mine: {
        type: Boolean,
        default: false
      },
      topText:{
        type:String,
        default: ' '
      },
      mainText:{
        type:String,
        default:' '
      }
    }
  }
</script>

<style scoped>
  .m-item-max-box{
    display: flex;
    padding: 0 10px;
    margin: 15px 0;
  }
  /*控制item在左边还是右边*/
  .m-item-max-box-end{justify-content: flex-end;}

  .m-item {
    max-width: 80%;
    display: flex;
  }
  .m-item .head-img {
    width: 48px;
    height: 48px;
  }

  /*三角形*/
  .left-right {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  /* 三角形指向 和 margin */
  .to-left {
    border-right: 10px solid #F4F4F4;
    margin: 20px 0 0 5px;
  }
  .to-right {
    border-left: 10px solid #F4F4F4;
    margin: 20px 5px 0 0;
  }

  /*时间姓名文字 align */
  .message-align-right {
    text-align: right;
  }

  .m-item .message-and-time {
    background: #F4F4F4;
    border-radius: 5px;
    padding: 10px;
    text-align: left;
  }
  .m-item .message-and-time > .time {
    color: #666666;
    font-size: 16px;
    margin-bottom: 5px !important;
  }
  .m-item .message-and-time > .content {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/message/MItem.vue